import CrudRepository from './CrudRepository'
export default class AllSegments extends CrudRepository {
  constructor () {
    super('core/api/segments/all')
  }
}
